import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { TypesUncertaintyTypes } from "../../app/types/genericTables.types";

type useTypesUncertaintyType = {
  typesUncertaintyList: TypesUncertaintyTypes[];
  get: (id: TypesUncertaintyTypes["id"]) => TypesUncertaintyTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useTypesUncertainty = create<useTypesUncertaintyType>(
  (set, get) => ({
    loading: false,
    typesUncertaintyList: [],
    query: "",
    setQuery: (query) => set({ query }),
    get: (id) => get().typesUncertaintyList.find((type) => type.id === id),
    fetchAll: async () => {
      set({ loading: true });
      try {
        const endpoint = "/generic/TipoIncertidumbre";

        const { data: response } = await getData(endpoint);
        set(() => ({
          typesUncertaintyList: response,
          loading: false,
        }));
      } catch (error) {
        console.error("Error fetching TipoIncertidumbre:", error);
        set({ loading: false });
      }
    },
  })
);
